import {
  formatDate,
  formatCurrentDateWithTimestampForFileName,
} from '../../../utils/date';
import printDoc from './pdf/printDoc';
import { printParams } from './pdf/pdfConfiguration';
import { columnTypes } from '../../../constants/globals';

export const EXCEL = 'EXCEL';
export const PDF = 'PDF';
export const CSV = 'CSV';
export const exportConstants = [EXCEL, PDF, CSV];

export const exportToPdfHandler = (gridRef, headerTitle, gt) => {
  const fileName = headerTitle ? generateExportFileName(headerTitle) : 'file';
  const printParamsForPdf = {
    ...printParams,
    fileName: fileName,
  };
  printDoc(printParamsForPdf, gridRef, fileName, gt);
};

export const getCellValue = (value, type, translation) => {
  switch (type) {
    case 'boolean':
      return value ? translation.BooleanValue.yes : translation.BooleanValue.no;
    case 'date':
      return value ? formatDate(value) : '';
    default:
      return value;
  }
};

export const getColumnName = (column) => {
  const columnName = column?.colId;
  const type = column?.colDef?.type;
  const thridChar = columnName[2];
  const startWithIsBooleanColumn =
    type === 'boolean' &&
    columnName.startsWith('is') &&
    thridChar === thridChar.toUpperCase();

  if (startWithIsBooleanColumn) {
    const firstCharacterLower = thridChar.toLowerCase();
    const columnNameSlice = columnName.slice(3);
    return `${firstCharacterLower}${columnNameSlice}`;
  }
  return columnName;
};

export const prepareForExport = (gridRef, gt, tableName) => {
  const allColumns =
    gridRef?.current?.columnApi?.getAllDisplayedColumns() || [];
  const fileName = generateExportFileName(tableName);
  const sheetName = tableName || 'Sheet';
  return {
    onlySelected: true,
    columnKeys: allColumns?.filter(
      (a) => a?.colDef?.type && a?.colDef?.type !== columnTypes.action
    ),
    processCellCallback(params) {
      const { column, node } = params || {};
      const type = column?.colDef?.type;
      const columnOfObj = getColumnName(column);
      const value = node.data?.[columnOfObj];
      return getCellValue(value, type, gt);
    },
    skipRowGroups: true,
    skipColumnGroupHeaders: true,
    fileName,
    sheetName,
  };
};

export function generateExportFileName(tableName) {
  return tableName
    ? `${tableName}_${formatCurrentDateWithTimestampForFileName()}`
    : 'file';
}
